'use es6';

import Actions from 'AdsUI/lib/Actions';
import { fetchConnectedAuths } from 'AdsUI/data/AccountConnectionData';
import { Networks } from 'AdsUI/lib/Constants';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import { addHeaderBanner } from 'AdsUI/actions/BannerActions';
import BannerTypes from 'AdsUI/lib/BannerTypes';
import fetchWithEarlyRequester from 'AdsUI/lib/fetchWithEarlyRequester';
import I18n from 'I18n';

const onSuccess = (dispatch, payload) => {
  dispatch({
    type: Actions.CONNECTED_USERS_FETCH_SUCCEEDED,
    payload
  });
  const expiredUsers = [];
  const expiringSoonUsers = [];
  payload.forEach(user => {
    if (user.network === Networks.FACEBOOK || user.network === Networks.LINKEDIN) {
      const {
        expiringSoon,
        authenticated
      } = user;

      if (!authenticated) {
        expiredUsers.push(user);
      } else if (user.network === Networks.LINKEDIN && expiringSoon) {
        /* We've decided not to spawn this banner for Facebook since the reauth
           date isn't actually reliable and it's been confusing for users.
           See AdsFrontend#1970.*/
        expiringSoonUsers.push(user);
      }
    }
  });

  if (expiredUsers.length === 1) {
    const [{
      userName,
      network
    }] = expiredUsers;
    dispatch(addHeaderBanner(BannerTypes.EXPIRATION_ALERT, [], {
      network,
      userName
    }));
  } else if (expiredUsers.length > 1) {
    dispatch(addHeaderBanner(BannerTypes.MULTI_EXPIRATION_ALERT, [], {
      users: expiredUsers
    }));
  }

  if (expiringSoonUsers.length === 1) {
    const [{
      expiresAt,
      userName,
      network
    }] = expiringSoonUsers;
    const expirationDate = I18n.moment(expiresAt).format('L');
    dispatch(addHeaderBanner(BannerTypes.EXPIRATION_WARNING, [], {
      network,
      userName,
      expirationDate
    }));
  } else if (expiringSoonUsers.length > 1) {
    dispatch(addHeaderBanner(BannerTypes.MULTI_EXPIRATION_WARNING, [], {
      users: expiringSoonUsers
    }));
  }
};

export default {
  fetch() {
    return dispatch => wrapReduxAction(fetchConnectedAuths, 'CONNECTED_USERS_FETCH', {
      dispatch,
      returnPromise: true,
      success: response => {
        onSuccess(dispatch, response);
      }
    });
  },

  fetchWithEarlyRequester() {
    return dispatch => wrapReduxAction(() => fetchWithEarlyRequester(fetchConnectedAuths, 'connected-auths'), 'CONNECTED_USERS_FETCH', {
      dispatch,
      returnPromise: true,
      success: response => {
        onSuccess(dispatch, response);
      }
    });
  }

};